import React from "react";
import timezoneIcon from "../../../assets/Images/time-zone-48.png";
import { TimeZone } from "../types/authTypes";

interface TimeZoneSelectProps {
  timeZones: TimeZone[];
  value: number | string;
  onChange: (value: number | string) => void;
  loading?: boolean;
}

export const TimeZoneSelect: React.FC<TimeZoneSelectProps> = ({ timeZones, value, onChange, loading = false }) => {
  return (
    <div className="mb-4">
      <label className="text-sm font-medium text-gray-600 mb-1 block">Time zone</label>

      <div className="flex items-center border rounded-lg px-3 py-2 bg-gray-50 focus-within:ring-2 focus-within:ring-blue-500">
        <span className="mr-2 text-gray-400">
          <img src={timezoneIcon} alt="timezone" style={{ width: 20, height: 20 }} />
        </span>
        <select value={value} onChange={(e) => onChange(e.target.value)} disabled={loading} className="w-full bg-transparent outline-none text-gray-700 disabled:opacity-50">
          <option value="" disabled>
            Select time zone
          </option>
          {timeZones.map((tz: TimeZone) => (
            <option key={tz.id} value={tz.id}>
              {tz.offset} - {tz.zone}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
